import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { AppService } from '../../_services/app.service';
import { ProductsService } from '../../_services/products.service';
import { ServerConn } from '../../_services/serverConn.service';
import { TWADialogsService } from '../../_services/twa-dialogs.service';

@Component({
  selector: 'app-product-partida-dialog',
  templateUrl: './product-partida-dialog.component.html',
  styleUrls: ['./product-partida-dialog.component.css'],
  standalone: false
})
export class ProductPartidaDialogComponent implements OnInit {
  title = 'Nueva partida';
  saving = false;
  comunidades: any[] = [];
  products: any[] = [];
  proveedores: any[] = [];
  stores: any[] = [];

  form = this.fb.group({
    idproducto: ['', Validators.required],
    idalmacen: ['', Validators.required],
    idcomunidad: ['', Validators.required],
    idproveedor: [''],
    fecha: [formatDate(new Date(), 'yyyy-MM-dd', 'en-US'), Validators.required],
    numeracion: ['', Validators.required],
    ultimo: [{ value: '', disabled: true }],
    cantidad: [1, [Validators.required, Validators.min(1)]],
    stock: [1, [Validators.required, Validators.min(0)]]
  });

  constructor(
    private dialogRef: MatDialogRef<ProductPartidaDialogComponent>,
    private fb: UntypedFormBuilder,
    private appSvc: AppService,
    private productsSvc: ProductsService,
    private server: ServerConn,
    private dlgsSvc: TWADialogsService
  ) { }

  ngOnInit(): void {
    this.appSvc.comunidades$.subscribe((data: any) => {
      this.comunidades = Array.isArray(data) ? data : [];
    });
    this.productsSvc.get().subscribe((res: any) => {
      const response = typeof res?.json === 'function' ? res.json() : res;
      if (response?.result && Array.isArray(response.data)) {
        this.products = response.data;
      }
    });
    this.productsSvc.getNewProductDetail().subscribe((res: any) => {
      const response = typeof res?.json === 'function' ? res.json() : res;
      const data = response?.data || response || {};
      this.proveedores = Array.isArray(data?.proveedores) ? data.proveedores : [];
    });
    this.server.get('stores').subscribe((res: any) => {
      const response = typeof res?.json === 'function' ? res.json() : res;
      this.stores = Array.isArray(response?.data) ? response.data : [];
    });
    this.form.controls.numeracion.valueChanges.subscribe(() => this.updateLastNumber());
    this.form.controls.cantidad.valueChanges.subscribe((cantidad) => {
      this.form.controls.stock.setValue(cantidad || 0, { emitEvent: false });
      this.updateLastNumber();
    });
  }

  displayProduct(product: any): string {
    return product?.nombre || '';
  }

  get filteredProducts(): any[] {
    const proveedor = this.form.controls.idproveedor.value;
    if (!proveedor) {
      return this.products;
    }
    return this.products.filter(product => String(product.idproveedor) === String(proveedor));
  }

  productChanged(product: any): void {
    if (product?.idproveedor) {
      this.form.controls.idproveedor.setValue(product.idproveedor);
    }
  }

  private updateLastNumber(): void {
    const numeracion = String(this.form.controls.numeracion.value || '');
    const cantidad = Number(this.form.controls.cantidad.value) || 0;
    const match = numeracion.match(/^(.*?)(\d+)$/);

    if (!match || cantidad < 1) {
      this.form.controls.ultimo.setValue('');
      return;
    }

    const prefix = match[1];
    const number = String(Number(match[2]) + cantidad - 1).padStart(match[2].length, '0');
    this.form.controls.ultimo.setValue(prefix + number);
  }

  save(force = false): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const data: any = { ...this.form.getRawValue() };
    data.idproducto = typeof data.idproducto === 'object' ? data.idproducto.id : data.idproducto;
    delete data.idproveedor;
    delete data.ultimo;
    data.fecha = formatDate(data.fecha, 'yyyy-MM-dd', 'en-US');
    if (force) {
      data.force = true;
    }

    this.saving = true;
    this.productsSvc.createPartida(data).subscribe(
      (res: any) => {
        const response = typeof res?.json === 'function' ? res.json() : res;
        this.saving = false;

        if (response?.result) {
          this.dialogRef.close(true);
          return;
        }

        if (response?.data?.duplicated) {
          this.dlgsSvc.confirm(
            'Partida duplicada',
            'Ya existe una partida con ese producto, fecha y numeración. ¿Deseas crearla igualmente?',
            'Sí, crear igualmente',
            'Cancelar'
          ).subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.save(true);
            }
          });
          return;
        }

        this.dlgsSvc.confirm(
          'No se ha podido crear la partida',
          response?.error || 'Revisa los datos e inténtalo de nuevo.',
          'Cerrar'
        ).subscribe();
      },
      () => {
        this.saving = false;
      }
    );
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
